/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const _TAB = '_TAB';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */

export const ACCOUNT_POPOVER_BUTTON = 'ACCOUNT_POPOVER_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ACCOUNT_SETTINGS_LINK = 'ACCOUNT_SETTINGS_LINK';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ADD_CUSTOM_FIELD_BUTTON = 'ADD_CUSTOM_FIELD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ADD_CUSTOM_FIELD_MINI_BUTTON = 'ADD_CUSTOM_FIELD_MINI_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const APPEARS_IN_BOARDS_HEADER = 'APPEARS_IN_BOARDS_HEADER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const APPLE_SIGN_IN_BUTTON = 'APPLE_SIGN_IN_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_ACTIONS_FAVORITE_BUTTON = 'ASSET_ACTIONS_FAVORITE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_CARD = 'ASSET_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_CARD_SUB_MENU = 'ASSET_CARD_SUB_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_CARD_SUB_MENU_BUTTON = 'ASSET_CARD_SUB_MENU_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_CARD_TITLE = 'ASSET_CARD_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER = 'ASSET_DOWNLOAD_DROPDOWN_MENU_TRIGGER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_CLOSE = 'ASSET_MODAL_CLOSE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_HEADER_ELLIPSIS = 'ASSET_MODAL_HEADER_ELLIPSIS';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_NEXT = 'ASSET_MODAL_NEXT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_NEXT_DISABLED = 'ASSET_MODAL_NEXT_DISABLED';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_PANEL_TITLE = 'ASSET_MODAL_PANEL_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_PREVIOUS = 'ASSET_MODAL_PREVIOUS';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_PREVIOUS_DISABLED = 'ASSET_MODAL_PREVIOUS_DISABLED';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_SHARE_BUTTON_PUBLIC = 'ASSET_SHARE_BUTTON_PUBLIC';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_SHARE_BUTTON_PRIVATE = 'ASSET_SHARE_BUTTON_PRIVATE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_NAME_CELL = 'ASSET_NAME_CELL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_TITLE = 'ASSET_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_ACTIONS_SUBMENU_BUTTON = 'BOARD_ACTIONS_SUBMENU_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_BLURB_CUSTOM_FIELDS = 'BOARD_BLURB_CUSTOM_FIELDS';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_BLURB_DESCRIPTION = 'BOARD_BLURB_DESCRIPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_CARD = 'BOARD_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_CARD_MENU = 'BOARD_CARD_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_CARD_MENU_BUTTON = 'BOARD_CARD_MENU_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_CARD_TITLE = 'BOARD_CARD_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RIVE_THUMBNAIL_CONTAINER = 'RIVE_THUMBNAIL_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RIVE_THUMBNAIL_ERROR = 'RIVE_THUMBNAIL_ERROR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RIVE_VISUALIZER = 'RIVE_VISUALIZER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RIVE_VISUALIZER_ERROR = 'RIVE_VISUALIZER_ERROR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RIVE_CONTAINER_DEFAULT_ERROR = 'RIVE_CONTAINER_DEFAULT_ERROR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_COLLECTION_ASSET_DETAILS_MODAL = 'BOARD_COLLECTION_ASSET_DETAILS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_DETAILS_INPUT = 'ASSET_DETAILS_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_COLLECTION_HERO = 'BOARD_COLLECTION_HERO';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_CRUMBS = 'board-crumbs';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_META = 'BOARD_META';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_PAGE_TABLE_HEADER = 'BoardPageTableHeader';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_PAGE_TABLE_VIEW = 'TableRow';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BULK_EDIT_SINGLE_SELECT_MODAL = 'BULK_EDIT_SINGLE_SELECT_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BULK_EDIT_MULTI_SELECT_MODAL = 'BULK_EDIT_MULTI_SELECT_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CDN_LINKS_MANAGER_PAGE = 'CDN_LINKS_MANAGER_PAGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CLEAR_SEARCH_TEXT_BTN = 'CLEAR_SEARCH_TEXT_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CLIP_PREVIEW_IMAGE = 'CLIP_PREVIEW_IMAGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONFIG_VIEWS_VISIBILITY = 'CONFIG_VIEWS_VISIBILITY';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONTINUE_WITH_SAML_SSO_BTN = 'CONTINUE_WITH_SAML_SSO_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONTENT_COLLECTION_FORM_MODAL_EDITABLE_TITLE = 'CONTENT_COLLECTION_FORM_MODAL_EDITABLE_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONTENT_COLLECTION_FORM_MODAL_EDITABLE_DESCRIPTION = 'CONTENT_COLLECTION_FORM_MODAL_EDITABLE_DESCRIPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONTENT_COLLECTION_FORM_MODAL_ADD_FIELD_BUTTON = 'CONTENT_COLLECTION_FORM_MODAL_ADD_FIELD_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const COPY_URL_BUTTON = 'COPY_URL_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const COPY_URL_FIELD_TEXT = 'copy-url-field-text';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CREATE_LINK_BUTTON = 'CREATE_LINK_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CREATE_NEW_TAG_BTN = 'CREATE_NEW_TAG_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CREATE_TAG_MODAL = 'CREATE_TAG_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CREATE_WORKSPACE_NAME_INPUT = 'CREATE_WORKSPACE_NAME_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CREATE_WORKSPACE_NAME_STEP_SUBMIT_BUTTON = 'CREATE_WORKSPACE_NAME_STEP_SUBMIT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_BUTTON = 'CURRENT_WORKSPACE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_HEADER_INFO = 'CURRENT_WORKSPACE_HEADER_INFO';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_NAV_SHOW_SORT_LIST_OPTIONS_BUTTON =
  'CURRENT_WORKSPACE_NAV_SHOW_SORT_LIST_OPTIONS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_NAV_SORT_LIST_OPTIONS_DROPDOWN = 'CURRENT_WORKSPACE_NAV_SORT_LIST_OPTIONS_DROPDOWN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_NAV_HIDE_TOGGLE_BUTTON = 'CURRENT_WORKSPACE_NAV_HIDE_TOGGLE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CURRENT_WORKSPACE_NAV_SHOW_TOGGLE_BUTTON = 'CURRENT_WORKSPACE_NAV_SHOW_TOGGLE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_CARD = 'CUSTOM_FIELD_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_DATE = 'CUSTOM_FIELD_DATE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_DELETE = 'CUSTOM_FIELD_DELETE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_DELETE_OPTION = 'CUSTOM_FIELD_OPTION_DELETE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_EDIT_BUTTON = 'CUSTOM_FIELD_EDIT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_ADD_NEW_OPTION = 'CUSTOM_FIELD_ADD_NEW_OPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_CANCEL = 'CUSTOM_FIELD_CANCEL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_OPTION = 'CUSTOM_FIELD_MODAL_OPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER = 'CUSTOM_FIELD_MODAL_OPTION_COLOR_MENU_TRIGGER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION = 'CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_OPTION_INPUT = 'CUSTOM_FIELD_MODAL_OPTION_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_MODAL_SAVE = 'CUSTOM_FIELD_SAVE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_PLAIN_TEXT = 'CUSTOM_FIELD_PLAIN_TEXT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_SAVE_OPTION = 'CUSTOM_FIELD_OPTION_SAVE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_SELECT_COMPONENT = 'CUSTOM_FIELD_SELECT_COMPONENT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_SELECT_LABEL = 'CUSTOM_FIELD_SELECT_LABEL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELD_TYPE_INPUT = 'CUSTOM_FIELD_TYPE_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CUSTOM_FIELDS_CONTEXT_MENU_EDIT = 'CUSTOM_FIELDS_CONTEXT_MENU_EDIT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DATE_CREATED_HEADER = 'DateCreatedHeader';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DATE_MODIFIED_HEADER = 'DateModifiedHeader';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DELETE_ASSETS_WARNING = 'DELETE_ASSETS_WARNING';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DELETE_TAGS_MODAL = 'DELETE_TAGS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DIMENSION_BAR_ASPECT_RATIO_BUTTON = 'DIMENSION_BAR_ASPECT_RATIO_BUTTON_';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DIMENSION_BAR_HEIGHT_INPUT = 'DIMENSION_BAR_HEIGHT_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DIMENSION_BAR_INPUT = 'DIMENSION_BAR_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DIMENSION_BAR_WIDTH_INPUT = 'DIMENSION_BAR_WIDTH_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION = 'DISCUSSION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOUNDING_BOX = 'BOUNDING_BOX';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_COMMENT_ADD_REPLY = 'DISCUSSION_COMMENT_ADD_REPLY';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_COMMENT_AVATAR = 'DISCUSSION_COMMENT_AVATAR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_REPLY_COMMENT_AVATAR = 'DISCUSSION_REPLY_COMMENT_AVATAR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_COMMENT_BODY = 'DISCUSSION_COMMENT_BODY';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_COMMENT_CONTAINER = 'ANNOTATION_COMMENT_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_COMMENT_MENU_TRIGGER = 'DISCUSSION_COMMENT_MENU_TRIGGER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_FORM_BUTTON_CANCEL = 'DISCUSSION_FORM_BUTTON_CANCEL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_FORM_BUTTON_SUBMIT = 'DISCUSSION_FORM_BUTTON_SUBMIT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_FORM_BUTTONS_CONTAINER = 'DISCUSSION_FORM_BUTTONS_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSION_HEADER_TIMESTAMP_PILL = 'DISCUSSION_HEADER_TIMESTAMP_PILL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const DISCUSSIONS_LIST = 'DISCUSSIONS_LIST';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EDIT_BOARD_INPUT = 'EDIT_BOARD_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EMPTY_BOARD = 'EMPTY_BOARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EXPIRATION_DATE_INPUT = 'EXPIRATION_DATE_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EXPIRATION_DATE_TOGGLE = 'EXPIRATION_DATE_TOGGLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EXPIRATION_DATE_SUBMIT_BUTTON = 'EXPIRATION_DATE_SUBMIT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPSELL_MODAL_TITLE = 'UPSELL_MODAL_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPSELL_MODAL_NEXT_BUTTON = 'UPSELL_MODAL_NEXT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPSELL_MODAL_PREV_BUTTON = 'UPSELL_MODAL_PREV_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPSELL_MODAL_SLIDE_BUTTON = 'UPSELL_MODAL_SLIDE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EXPORT_IMAGES_MODAL = 'EXPORT_IMAGES_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EXPORT_IMAGES_SUFFIX_INPUT = 'EXPORT_IMAGES_SUFFIX_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILE_CARD = 'FILE_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILE_CARD_SUB_MENU = 'FILE_CARD_SUB_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILE_CARD_SUB_MENU_BUTTON = 'FILE_CARD_SUB_MENU_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILE_CARD_TITLE = 'FILE_CARD_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILE_HEADER = 'file-header';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FOLLOW_BUTTON = 'FOLLOW_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FOLLOW_DROPDOWN_BUTTON = 'FOLLOW_DROPDOWN_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FORGOT_PASSWORD_EMAIL_INPUT = 'FORGOT_PASSWORD_EMAIL_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FORGOT_PASSWORD_SUBMIT_BUTTON = 'FORGOT_PASSWORD_SUBMIT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GENERATE_CDN_LINK_BUTTON = 'GENERATE_CDN_LINK_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GENERATE_CDN_MODAL_FORMAT_SELECT_FIELD = 'GENERATE_CDN_MODAL_FORMAT_SELECT_FIELD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GOOGLE_SIGN_IN_BUTTON = 'GOOGLE_SIGN_IN_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GUEST_ACCESS_MODAL = 'GUEST_ACCESS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GUEST_ROLE_MENU = 'GUEST_ROLE_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const GUEST_UPGRADE_CONFIRMATION_MODAL = 'GUEST_UPGRADE_CONFIRMATION_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_FORMAT_SINGLE_SELECT = 'IMAGE_FORMAT_SINGLE_SELECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_SIZE_SINGLE_SELECT = 'IMAGE_SIZE_SINGLE_SELECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMPORT_MODAL = 'IMPORT_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMPORT_MODAL_CLOSE_BUTTON = 'IMPORT_MODAL_CLOSE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const INFO_PANEL_DESCRIPTION = 'INFO_PANEL_DESCRIPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const INFO_PANEL_FILE_EXTENSION = 'INFO_PANEL_FILE_EXTENSION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const INFO_PANEL_TITLE = 'INFO_PANEL_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_COLUMN = 'KANBAN_COLUMN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_COLUMN_HEADER = 'KANBAN_COLUMN_HEADER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_COLUMN_HEADER_ITEM_COUNT = 'KANBAN_COLUMN_HEADER_ITEM_COUNT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_COLUMN_SPINNER = 'KANBAN_COLUMN_SPINNER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_GROUP_BY_MENU = 'KANBAN_GROUP_BY_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KANBAN_VIEW_CONTAINER = 'KANBAN_VIEW_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LIST_SECTION_TITLE = 'LIST_SECTION_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOADING_BIRD = 'LOADING_BIRD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOADING_SPINNER = 'LOADING_SPINNER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOG_IN_LINK = 'LOG_IN_LINK';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOGIN_EMAIL_INPUT = 'LOGIN_EMAIL_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOGIN_PASSWORD_INPUT = 'LOGIN_PASSWORD_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LOGIN_SUBMIT_BUTTON = 'LOGIN_SUBMIT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MAIN_NAVIGATION = 'main-navigation';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MAINTENANCE_MODE_BANNER_MESSAGE = 'MAINTENANCE_MODE_BANNER_MESSAGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MEMBERS_LIMIT_REDIRECT = 'MEMBERS_LIMIT_REDIRECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MEMBERS_BREAKDOWN_MODAL = 'MEMBERS_BREAKDOWN_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MENTIONS_TIMESTAMP_PILL = 'MENTIONS_TIMESTAMP_PILL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MERGE_TAGS_MODAL = 'MERGE_TAGS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MODAL_LABEL = 'MODAL_LABEL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const NAME_HEADER = 'NameHeader';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const NEW_ACTION_BUTTON = 'NEW_ACTION_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const NO_FAVORITES_TITLE = 'NO_FAVORITES_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const NOT_FOUND_CONTENT = 'NOT_FOUND_CONTENT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const AIR_NOTIFICATIONS_BUTTON = 'AIR_NOTIFICATIONS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const AIR_NOTIFICATIONS_BUTTON_BADGE = 'AIR_NOTIFICATIONS_BUTTON_BADGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const AIR_NOTIFICATIONS_POPOVER = 'AIR_NOTIFICATIONS_POPOVER';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ORGANIZE_YOUR_FILES_MODAL = 'ORGANIZE_YOUR_FILES_MODAL';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PASSCODE_PROTECTED_SHARE_PAGE_INPUT = 'PASSCODE_PROTECTED_SHARE_PAGE_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PASSCODE_PROTECTION_UPSELL_BUTTON = 'PASSCODE_PROTECTION_UPSELL_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PLAN_USAGE_INFO_STORAGE = 'PLAN_USAGE_INFO_STORAGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PLAY_PAUSE_BUTTON = 'PLAY_PAUSE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PROGRESS_BAR = 'PROGRESS_BAR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PROGRESS_BAR_INDICATOR = 'PROGRESS_BAR_INDICATOR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PUBLIC_BOARD_CHILDREN_CONTAINER = 'PUBLIC_BOARD_CHILDREN_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PUBLIC_TOP_BAR_LOGO = 'PUBLIC_TOP_BAR_LOGO';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CLEAR_SELECTED_VALUES_BUTTON = 'CLEAR_SELECTED_VALUES_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RESOLUTION_HEADER = 'resolution-header';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const RETRY_INVITE_BUTTON = 'RETRY_INVITE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SAVED_FILTER_UPDATE_BUTTON = 'SAVED_FILTER_UPDATE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_BOARD_TOKEN = 'SEARCH_BOARD_TOKEN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_LIBRARY_TOKEN = 'SEARCH_LIBRARY_TOKEN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_TOKEN_CLOSE_BTN = 'SEARCH_TOKEN_CLOSE_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_CLOSE = 'SEARCH_CLOSE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_CONTAINER = 'SEARCH_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_INPUT = 'SEARCH_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_INPUT_CONTAINER = 'SEARCH_INPUT_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_RESULTS_TEXT = 'SEARCH_RESULTS_TEXT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_SUGGESTION = 'SEARCH_SUGGESTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEARCH_SUGGESTIONS_CONTAINER = 'SEARCH_SUGGESTIONS_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SELECT_INPUT_FIELD = 'SELECT_INPUT_FIELD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SELECTED_CHIP = 'SELECTED_CHIP';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SEND_PASSCODE_BUTTON = 'SEND_PASSCODE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SET_AS_BOARD_THUMBNAIL_BUTTON = 'SET_AS_BOARD_THUMBNAIL_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SHARE_BUTTON = 'BOARD_SHARE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_EMAIL_INPUT = 'SIGN_UP_EMAIL_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_FIRST_NAME_INPUT = 'SIGN_UP_FIRST_NAME_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_LAST_NAME_INPUT = 'SIGN_UP_LAST_NAME_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_NEXT_BUTTON = 'SIGN_UP_NEXT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_PASSWORD_INPUT = 'SIGN_UP_PASSWORD_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_TERMS_INPUT = 'SIGN_UP_TERMS_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIGN_UP_CONTINUE_BUTTON = 'SIGN_UP_CONTINUE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SORT_BUTTON = 'SORT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SORT_BUTTON_ARROW = 'SORT_BUTTON_ARROW';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SORT_BUTTON_TYPE = 'SORT_BUTTON_TYPE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SORT_MENU_TRIGGER_CARET = 'SORT_MENU_TRIGGER_CARET';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const STORAGE_METER_NUMBERS = 'STORAGE_METER_NUMBERS';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SUBSCRIPTION_EXPIRATION_BANNER_INVALID = 'SUBSCRIPTION_EXPIRATION_BANNER_INVALID';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TABLE_ASSET_TITLE = 'TABLE_ASSET_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TABLE_CUSTOM_FIELD_CELL_BUTTON = 'TABLE_CUSTOM_FIELD_CELL_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TABLE_ROW = 'TableRow';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TABLE_ROW_CELL = 'TABLE_ROW_CELL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_CHECKBOX = 'TAG_CHECKBOX';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_EDIT_TITLE = 'TAG_EDIT_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_NAME_INPUT = 'TAG_NAME_INPUT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_ROW = 'TAG_ROW_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_ROW_COUNT = 'TAG_ROW_COUNT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_ROW_MENU_BTN = 'TAG_ROW_MENU_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_ROW_NAME = 'TAG_ROW_NAME';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAG_TO_MERGE_INTO_SELECT = 'TAG_TO_MERGE_INTO_SELECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAGS_MANAGER_PAGE = 'TAGS_MANAGER_PAGE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TAGS_TO_MERGE_SELECT = 'TAGS_TO_MERGE_SELECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TIMESTAMP_INPUT_BUTTON = 'TIMESTAMP_INPUT_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TIMESTAMP_MARKER_AVATAR = 'VIDEO_TIMESTAMP_MARKER_AVATAR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const COMMENTS_FILTER_MENU = 'COMMENTS_FILTER_MENU';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TRANSACTION_MODAL_PRIMARY_CTA = 'TRANSACTION_MODAL_PRIMARY_CTA';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TYPE_HEADER = 'TYPE_HEADER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPLOAD_VERSIONS_MODAL = 'UPLOAD_VERSIONS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const WORKSPACE_ACTIVITY_BUTTON = 'WORKSPACE_ACTIVITY_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPLOADER_SELECT = 'UPLOADER_SELECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPLOADING_ASSET = 'UPLOADING_ASSET';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPLOADING_FILE = 'UPLOADING_FILE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const USERS_BILLING_STATUS = 'USERS_BILLING_STATUS';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const VIEW_TYPE_MENU_TOGGLE = 'VIEW_TYPE_MENU_TOGGLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const VISIBILITY_TOGGLE = 'VISIBILITY_TOGGLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const VISIBILITY_TOGGLE_HEADER = 'VISIBILITY_TOGGLE_HEADER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const VISIBILITY_TOGGLE_SWITCH = 'VISIBILITY_TOGGLE_SWITCH';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const WORKSPACE_NAV_WORKSPACE_BUTTON = 'WORKSPACE_NAV_WORKSPACE_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const WORKSPACE_REDIRECT = 'WORKSPACE_REDIRECT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const WORKSPACE_SELECT_MODAL = 'WORKSPACE_SELECT_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const X_BUTTON = 'X_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ADD_FILTER_BUTTON = 'ADD_FILTER_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const APPLY_FILTERS_BUTTON = 'APPLY_FILTERS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CLEAR_ALL_FILTERS_BUTTON = 'CLEAR_ALL_FILTERS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILTERS_DROPDOWN = 'FILTERS_DROPDOWN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILTER_SELECT_BTN = 'FILTER_SELECT_BTN';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILTER_CARD = 'FILTER_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FILTER_ROW_CHECKBOX = 'FILTER_ROW_CHECKBOX';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const NEW_FILTERS_BUTTON = 'NEW_FILTERS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SINGLE_FILTER_CARD = 'SINGLE_FILTER_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SINGLE_SELECT_OPTION = 'SINGLE_SELECT_OPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CONTINUE_WITH_PASSWORD = 'CONTINUE_WITH_PASSWORD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SAML_SSO_FORM = 'SAML_SSO_FORM';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ORIENTATION_FILTER_CARD = 'ORIENTATION_FILTER_CARD';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SINGLE_SELECT_VALUE = 'SINGLE_SELECT_VALUE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SELECT_LOADING = 'SELECT_LOADING';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const BOARD_NAME_CELL = 'BOARD_NAME_CELL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ALL_CONTENT_PAGE_CONTENT = 'ALL_CONTENT_PAGE_CONTENT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const LIBRARY_PAGE_CONTENT = 'LIBRARY_PAGE_CONTENT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FAST_FILTER_PAGE_CONTENT = 'FAST_FILTER_PAGE_CONTENT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const TOGGLE_EDIT_ANNOTATIONS_BUTTON = 'TOGGLE_EDIT_ANNOTATIONS_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const KEYBOARD_SHORTCUTS_MODAL = 'KEYBOARD_SHORTCUTS_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const COMMENT_METADATA_CONTAINER = 'COMMENT_METADATA_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_PAGE_NUMBER = 'ANNOTATION_PAGE_NUMBER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_INDICATOR = 'ANNOTATION_INDICATOR';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_COMMENT_FORM = 'ANNOTATION_COMMENT_FORM';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const EDIT_COMMENT_FORM = 'EDIT_COMMENT_FORM';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const REPLY_COMMENT_FORM = 'REPLY_COMMENT_FORM';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_AVATAR_BUTTON = 'ANNOTATION_AVATAR_BUTTON';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CLOSE_FLOATING_COMMENT_BUTTON = 'CLOSE_FLOATING_COMMENT_BUTTON';

/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SHARE_PRIVATE_CONTENT_MODAL = 'SHARE_PRIVATE_CONTENT_MODAL';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MENTION_SUGGESTION = 'MENTION_SUGGESTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const MENTION_SUGGESTIONS_CONTAINER = 'MENTION_SUGGESTIONS_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const VIEW_CONTROLS_HEADER_TEXT = 'VIEW_CONTROLS_HEADER_TEXT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ASSET_MODAL_PROCESSING_TEXT = 'ASSET_MODAL_PROCESSING_TEXT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIDEBAR_NAVIGATION_ITEM_MORE = 'SIDEBAR_NAVIGATION_ITEM_MORE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIDEBAR_NAVIGATION_ITEM_SAVED_FILTERS = 'SIDEBAR_NAVIGATION_ITEM_SAVED_FILTERS';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const SIDEBAR_NAVIGATION_SAVED_FILTERS_EDIT = 'SIDEBAR_NAVIGATION_SAVED_FILTERS_EDIT';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PRIVATE_CONTENT_SPINNER_TEST_ID = 'PRIVATE_CONTENT_SPINNER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const PRIVATE_SHARE_LINK = 'PRIVATE_SHARE_LINK';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FRAME_CONTROL = 'frame-control';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const FRAME_CONTROL_DISABLED = 'frame-control-disabled';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const UPSELL_FLASH_ICON_BUTTON = 'UPSELL_FLASH_ICON_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const ANNOTATION_TOOL_PENCIL_BUTTON = 'ANNOTATION_TOOL_PENCIL_BUTTON';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_SEARCH_INFO_MESSAGE_CONTAINER = 'IMAGE_SEARCH_INFO_MESSAGE_CONTAINER';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_SEARCH_INFO_MESSAGE_TITLE = 'IMAGE_SEARCH_INFO_MESSAGE_TITLE';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_SEARCH_INFO_MESSAGE_DESCRIPTION = 'IMAGE_SEARCH_INFO_MESSAGE_DESCRIPTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const IMAGE_SEARCH_INFO_MESSAGE_ACTION = 'IMAGE_SEARCH_INFO_MESSAGE_ACTION';
/**
 * @deprecated This file is deprecated
 * @see https://github.com/AirLabsTeam/next/blob/develop/.ai/testing.md#L71
 */
export const CAPTURED_TEXT_LIST_CONTAINER = 'CAPTURED_TEXT_LIST_CONTAINER';
